/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
  <div class="pdf-page-container">
    <header class="pdf-page-header">
      <div class="header-logo-box">
      </div>
      <div class="header-brand-info">
        <p class="doc-subtitle">Propuesta Fotovoltaica </p> 
      </div>
    </header>

    <main class="pdf-page-content">
      <slot></slot>
    </main>

    <footer class="pdf-page-footer">
      <div class="footer-line"></div>
      <div class="footer-details">
      </div>
    </footer>
  </div>
</template>

<style scoped>
.pdf-page-container {
  width: 210mm;
  height: 296mm; 
  background: white;
  padding: 10mm 15mm;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  page-break-after: avoid; 
  page-break-inside: avoid;
  overflow: hidden; 
}

.pdf-page-content {
  flex-grow: 1;
}

.pdf-document-wrapper > .pdf-page-container:not(:last-child) {
  page-break-after: HTMLElement; 
  display: block; 
}

.pdf-page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #29b9f6;
  padding-bottom: 5mm;
  margin-bottom: 5mm;
}

.logo-img { height: 35px; width: auto; }
.brand-name { font-size: 14px; font-weight: 800; color: #2d3748; }
.doc-subtitle { font-size: 9px; color: #718096; text-transform: uppercase; }

.pdf-page-footer {
  margin-top: 10mm;
  page-break-after: always; /* Esto asegura que el logo se repita en la siguiente hoja */
}

.pdf-page-footer:last-child {
  page-break-after: auto;
}
</style>